import { useUserStore } from '@/store';

//引入自定义指令文件【控制按钮显示权限】
export const isHasBtn = (app: any) => {
  const userStore = useUserStore();
  app.directive('has', {
    mounted(el: any, options: any) {
      if (!userStore.btns.includes(options.value)) {
        el.parentNode.removeChild(el);
      }
    }
  });
};
